import {
  AvatarEntity,
  UsersPermissionsUserEntity,
  UsersPermissionsUserEntityResponse
} from '../../../graphql/generated/graphql';
import { Avatar, AvatarMedia } from '../../../types/avatar/avatarList.def';

export const getAvatarMediaFromQuery: (
  avatar: Partial<AvatarEntity>
) => AvatarMedia = avatar => ({
  media: { url: avatar?.attributes?.media?.data?.attributes?.url }
});

export const getAvatarListFromQuery: (
  avatars: Partial<AvatarEntity>[]
) => Avatar[] = avatars =>
  avatars.map(a => ({
    id: a?.id,
    name: a?.attributes?.name,
    ...getAvatarMediaFromQuery(a)
  }));

export const getAvatarUrlFromUserQuery = (
  user: UsersPermissionsUserEntityResponse
) => getAvatarMediaFromQuery(user.data?.attributes?.avatar?.data)?.media?.url;

export const getAvatarUrlFromPedagogicalChallengeQuery = (
  user: UsersPermissionsUserEntity
) =>
  user.attributes?.avatar?.data?.attributes?.media?.data?.attributes?.url
    ? user.attributes.avatar.data.attributes.media.data.attributes.url
    : null;
